// NPM
import Api from '@/services/api';
import { defineStore } from 'pinia';

export const useCommonStore = defineStore('common', {
  state: () => {
    return {
      adminModal: {
        props: {} as { [key: string]: any },
      },
      alert: {
        props: {},
        // bumped on every setAlert so the toast re-mounts (and replays its animation) even for an identical message
        id: 0,
      },
      alertTimeoutId: null as ReturnType<typeof setTimeout> | null,
      callTextModal: {
        props: {} as { [key: string]: any },
      },
      manageChallengesModal: {
        props: {} as { [key: string]: any },
      },
      manageRewardsModal: {
        props: {} as { [key: string]: any },
      },
      manageUgcsModal: {
        props: {} as { [key: string]: any },
      },
      feedbackRelationModal: {
        props: {} as { [key: string]: any },
      },
      reportModal: {
        props: {} as { [key: string]: any },
      },
      shareModal: {
        props: {} as { [key: string]: any },
      },
      slideOverModal: {
        props: {} as { [key: string]: any },
      },
      touchpointsModal: {
        props: {} as { [key: string]: any },
      },
      qrCodeModal: {
        props: {} as { [key: string]: any },
      },
    };
  },

  actions: {
    setAdminModal(props?: { [key: string]: any }) {
      this.adminModal.props = props || {};
    },

    setAlert(props?: { [key: string]: any }) {
      // Cancel the previous alert's timer, otherwise it would hide this new alert early
      if (this.alertTimeoutId !== null) clearTimeout(this.alertTimeoutId);

      this.alert = {
        props: props || {},
        id: this.alert.id + 1,
      };

      this.alertTimeoutId = setTimeout(() => this.resetAlert(), props?.duration || 3000);
    },

    resetAlert() {
      if (this.alertTimeoutId !== null) clearTimeout(this.alertTimeoutId);
      this.alertTimeoutId = null;

      this.alert = {
        props: {},
        id: this.alert.id,
      };
    },

    setCallTextModal(props?: { [key: string]: any }) {
      this.callTextModal.props = props || {};
    },

    setManageChallengesModal(props?: { [key: string]: any }) {
      this.manageChallengesModal.props = props || {};
    },

    setManageRewardsModal(props?: { [key: string]: any }) {
      this.manageRewardsModal.props = props || {};
    },

    setManageUgcsModal(props?: { [key: string]: any }) {
      this.manageUgcsModal.props = props || {};
    },

    setFeedbackRelationModal(props?: { [key: string]: any }) {
      this.feedbackRelationModal.props = props || {};
    },

    setReportModal(props?: { [key: string]: any }) {
      this.reportModal.props = props || {};
    },

    setShareModal(props?: { [key: string]: any }) {
      this.shareModal.props = props || {};
    },

    setSlideOverModal(props?: { [key: string]: any }) {
      this.slideOverModal.props = props || {};
    },

    setTouchpointsModal(props?: { [key: string]: any }) {
      this.touchpointsModal.props = props || {};
    },

    setQrCodeModal(props?: { [key: string]: any }) {
      this.qrCodeModal.props = props || {};
    },

    closeAdminModal() {
      this.adminModal.props.open = false;
    },

    closeCallTextModal() {
      this.callTextModal.props.open = false;
    },

    closeManageChallengesModal() {
      this.manageChallengesModal.props.open = false;
    },

    closeManageRewardsModal() {
      this.manageRewardsModal.props.open = false;
    },

    closeManageUgcsModal() {
      this.manageUgcsModal.props.open = false;
    },

    closeFeedbackRelationModal() {
      this.feedbackRelationModal.props.open = false;
    },

    closeReportModal() {
      this.reportModal.props.open = false;
    },

    closeShareModal() {
      this.shareModal.props.open = false;
    },

    closeSlideOverModal(closeType?: string) {
      if (closeType) {
        this.slideOverModal.props.closeType = closeType;
      }
      this.slideOverModal.props.open = false;
    },

    closeTouchpointsModal() {
      this.touchpointsModal.props.open = false;
    },

    closeQrCodeModal() {
      this.qrCodeModal.props.open = false;
    },

    async testError() {
      await Api.main().test.testError();
    },
  },
});
